import Scene from './Scene';
import Game from '../Game';
import RenderSystem from '../System/Render/RenderSystem';
import AnimationSystem from '../System/Animation/AnimationSystem';
import TransitionSystem from '../System/TransitionSystem';

export default class TransitionScene extends Scene {
    public init(): void {
        this.addSystem(new TransitionSystem(Game.store));
        this.addSystem(new AnimationSystem(Game.store));
        this.addSystem(new RenderSystem(Game.store));

        this.systems.forEach(system => system.init());
    }

    public async preload() {
        Game.resource.add(
            'transition_bg',
            'resource/graphics/other/loading_bg.jpg'
        );

        Game.resource.add(
            'LoadingScreen',
            'resource/graphics/sprite_sheets/loadingscreen.json'
        );

        return Game.resource.load();
    }
}
